import React, { Component } from "react";
import style from "./CreateInvoice.module.css";
//import DatePicker from "react-datepicker";
import { DatePicker } from "antd";
import moment from "moment";
import { Button } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { connect } from "react-redux";
import Datetime from 'react-datetime';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import "react-datetime/css/react-datetime.css";
import {
  fetchInvoiceData,
  fetchPreInvoice,
  fetchpractitioner,
  fetchpatient,
  fetchRelatedParty,
  fetchCombinedPractitioner,
  fetchExternalPractitionerAutoComp
} from "../../../redux";
import api from "../../../utils/Api";
import ttmLoader from "../../../assets/images/ttm-loader.gif";
import history from "../../../utils/history";
import {
  checkIfPermitted,
  Permissions,
} from "../../../services/RolePermissionService";
import * as Yup from "yup";
import BillingComponent from "../BillingComponent/BillingComponent";
import { Select } from "antd";
import { isEmpty } from "lodash";
import { dateFormatter, formatNumberToCurrency } from "../../../utils/CommonUtil";
const { Option } = Select;


const lineItemObj = {
  "line_type": '',
  "tariff_code": "",
  "nappi_code": "",
  "description": "",
  "doctor_id": "",
  "quantity": "",
  "price": "",
  "days_of_therapy": "",
  "authorization_number": "",
  "re-submission_reason_code": "",
  "place_of_service_code": "",
  "diagnosis_code": ""
};

const diagnosisObj = {
  "doctor_type_code": "",
  "diagnosis_code_type": "",
  "diagnosis_code": "",
  "diagnosis_description": "",
  "extended_diagnosis": ""
};

export class CreateInvoice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      invoice_id: "",
      invoice_type_id: "",
      bill_to: "",
      age: "",
      dob: "",
      date: moment(),
      startdatetime: moment().subtract(1,"minutes"),
      enddatetime: moment(),
      address: "",
      related_party: "",
      patient_type: "01",
      requested_professional: "",
      place_of_treatment_code: "11",
      billing_policy_configuration_id: "",
      billing_policy_value: "",
      referring_practitioner_id: "",
      referring_to_practitioner_id: "",
      appoinment_id: "",
      conductappointment_id: "",
      medicalplan: "",
      email: "",
      diagnosisArr: "",
      lineItemsArray: [],
      diagnosis_codes: [],
      sub_total: "",
      vat_amount: "",
      vat_percent:
        localStorage.getItem("SETTING_INFO") &&
        JSON.parse(localStorage.getItem("SETTING_INFO")).vat_percent,
      total: 0,
      claimed_amount: 0,
      patient_liable_amount: 0,
      scheme_liable_amount: 0,
      amount_paid: 0,
      balance: 0,
      appointment_reason: "",
      description: "",
      successMessage: "",
      errorMessage: "",
      isLoading: false,
      error: "",
      resubmission_code: "",
      claimAsAssistant: 0,
      isScreenLoaded: false,
      isEstimate : 0,
      isSelectionModal: false,
      isSelectionDone: false,
      isAllClaimed: 0,
      claimLineNotSelectedErr: "",
      discount:0,
      writeoff_amount:0,
      zeroModal: false
    };
  }

  zeroModalPopup= (event) => {
    console.log("aslkdkasd", event)
    const priceZeroItem = this.state?.lineItemsArray?.findIndex((item) => item.price === 0)
    if(priceZeroItem !== -1){
    this.setState({ zeroModal: !this.state.zeroModal })}
    else this.submitForClaim(false);
  }

  zeroModalConfirmation = (param) => {
     this.setState({
          zeroModal: !this.state.zeroModal})
    this.submitForClaim(param);
  }

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    let path = this.props.location.pathname;
    if(path.includes("/app/createestimate")){
      this.setState({
        title: "Create Estimate",
        isEstimate : 1
      })
      document.title = 'Create Estimate - TechToMedix';
    }else{
      this.setState({
        title: "Create Invoice"
      })
       document.title = 'Create Invoice - TechToMedix';
    }

    // calling patient autocomplete data
    await this.props.fetchpatient(this.state.bill_to);

    // Calling practitioner autocomplete data
    await this.props.fetchpractitioner(this.state.requested_professional);
    await this.props.fetchCombinedPractitioner("");
    await this.props.fetchExternalPractitionerAutoComp("");
   // console.log("this.props", this.props);
    if (this.props.location.state && this.props.location.state.resubmission_code) {
      this.setState({
        resubmission_code: this.props.location.state.resubmission_code
      })
    }
    if (this.props.match && this.props.match.params && this.props.match.params.id) {

      if(path.includes("/app/createestimate")){
        document.title = 'Edit Estimate - TechToMedix';
        this.setState({
          title: "Edit Estimate",
          invoice_id: this.props.match.params.id
        })
      }else{
         document.title = 'Edit Invoice - TechToMedix';
         this.setState({
           title: "Edit Invoice",
           invoice_id: this.props.match.params.id
         })
      }
      await this.props.fetchInvoiceData(this.props.match.params.id);


      if (!this.props.invoiceDataDetails.loading && this.props.invoiceDataDetails.invoiceData) {

        let data = this.props.invoiceDataDetails.invoiceData;

        this.setState({
          related_party: data && data.associated_related_party_id,
          requested_professional: data && data.requested_related_party_id,
          appoinment_id: data && data.appointment_id,
          conductappointment_id: data && data.conductappointment_id,
          invoice_type_id: data && data.invoice_type_id,
          patient_type: data && data.patient_type,
          place_of_treatment_code: data && data.place_of_treatment_code,
          billing_policy_configuration_id: data && data.billing_policy_configuration_id,
          billing_policy_value: data && data.billing_policy_value ? data.billing_policy_value : 0,
          referring_practitioner_id: data && data.referring_practitioner_id,
          referring_to_practitioner_id: data && data.referring_to_practitioner_id,
          bill_to: data && data.billTo,
          address: data && data.address?data.address:"",
          email: data && data.billing_email? data.billing_email: "",
          date: data && moment(data.invoice_date),
          startdatetime: data && moment(data.startdatetime),
          enddatetime: data && moment(data.enddatetime),
          weight: data && data.weight,
          height: data && data.height,
          lineItemsArray: data && data.treatmentLineItems,
          sub_total: data && data.sub_total,
          vat_amount: data && data.vat_amount,
          total: data && data.total,
          vat_percent: data && data.vat_percent,
          diagnosis_codes: data && data.diagnosis,
          isMedicalAidPatient: data && data.isMedicalAidPatient,
          claimAsAssistant: data && data.claimAsAssistant === 1 ? data.claimAsAssistant : 0,
          claimed_amount: data && data.claimed_amount,
          patient_liable_amount: data && data.patient_liable_amount,
          scheme_liable_amount: data && data.scheme_liable_amount,
          amount_paid: data && data.amount_paid,
          balance: data && data.balance,
          age: data && data.age,
          dob: data && dateFormatter(data.dob),
          discount:data && data.discount,
          firstConsultationConfiguration:(data && data.firstConsultationConfiguration)||[],
          billing_policy_id:data.billing_policy_id,
          writeoff_amount:data && data.writeoff_amount
        },()=>{
          this.updateStartEndTimeInLineItems();
        });
      }

    } else if (this.props.location.state) {
      this.setState({
        appointment_reason:
          this.props.location.state &&
          this.props.location.state.appointment_reason,
      });
      if (
        this.props.location.state &&
       // this.props.location.state.paymentType !== "1" &&
        this.props.location.state.appoinment_id &&
        this.props.location.state.related_party &&
        this.props.location.state.related_party.related_party_id 
       //&& this.props.location.state.conductappointment_id
      ) {
        await this.props.fetchPreInvoice(
          this.props.location.state.appoinment_id,
          this.props.location.state.related_party.related_party_id,
          this.props.location.state.conductappointment_id,
          this.state.isEstimate
        );


        if (this.props.preInvoiceData && this.props.preInvoiceData.preInvoiceList) {
          // calculate addition
          const sum_amount =
            this.props.preInvoiceData.preInvoiceList.diagnosis &&
            this.props.preInvoiceData.preInvoiceList.diagnosis
              .map((item) => item.amount)
              .reduce((prev, curr) => prev + curr, 0);

          const vat_calc = sum_amount * (this.state.vat_percent / 100);

          const total_amount = sum_amount + vat_calc;

          let invoice_type_id =
            this.props.preInvoiceData.preInvoiceList &&
            this.props.preInvoiceData.preInvoiceList.invoice_type_id;
          if (this.props.preInvoiceData.preInvoiceList &&
            this.props.preInvoiceData.preInvoiceList.isMedicalAidPatient === 1) {
            invoice_type_id = 1;
          }


          this.setState({
            related_party: this.props.location.state.related_party.related_party_id,
            requested_professional: this.props.location.state.requsted_professional
              .related_party_id,
            appoinment_id: this.props.location.state.appoinment_id,
            conductappointment_id: this.props.location.state.conductappointment_id,
            authorization_number: this.props.location.state.authorization_number,
            invoice_type_id: invoice_type_id,
            patient_type:
              this.props.preInvoiceData.preInvoiceList &&
                this.props.preInvoiceData.preInvoiceList.patient_type ?
                this.props.preInvoiceData.preInvoiceList.patient_type : this.state.patient_type,
            place_of_treatment_code:
              this.props.preInvoiceData.preInvoiceList &&
                this.props.preInvoiceData.preInvoiceList.place_of_treatment_code ?
                this.props.preInvoiceData.preInvoiceList.place_of_treatment_code : this.state.place_of_treatment_code,
            billing_policy_configuration_id:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.billing_policy_configuration_id,
            billing_policy_value:
            this.props.preInvoiceData.preInvoiceList &&
            this.props.preInvoiceData.preInvoiceList.billing_policy_value ? this.props.preInvoiceData.preInvoiceList.billing_policy_value : 0,
            referring_practitioner_id:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.referring_practitioner_id,
            referring_to_practitioner_id:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.referring_to_practitioner_id,
            bill_to:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.billTo,
            address:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.billing_address? this.props.preInvoiceData.preInvoiceList.billing_address: "",
            email:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.billing_email?this.props.preInvoiceData.preInvoiceList.billing_email: "",
            medicalplan:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.medical_plan,
            diagnosis_codes:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.diagnosis,
            lineItemsArray:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.treatementDetail,
             weight: 
             this.props.preInvoiceData.preInvoiceList &&
             this.props.preInvoiceData.preInvoiceList.weight,
             height:
             this.props.preInvoiceData.preInvoiceList &&
             this.props.preInvoiceData.preInvoiceList.height,
            isMedicalAidPatient:
              this.props.preInvoiceData.preInvoiceList &&
              this.props.preInvoiceData.preInvoiceList.isMedicalAidPatient,
            sub_total: sum_amount,
            vat_amount: vat_calc,
            total: total_amount,
            age: this.props.preInvoiceData.preInvoiceList &&
            this.props.preInvoiceData.preInvoiceList.age,
            dob: this.props.preInvoiceData.preInvoiceList &&
            dateFormatter(this.props.preInvoiceData.preInvoiceList.dob),
            // startdatetime:moment(this.props.preInvoiceData.preInvoiceList.startDateTime),
            // enddatetime:moment(this.props.preInvoiceData.preInvoiceList.endDateTime)
            startdatetime:moment(moment(this.props.preInvoiceData.preInvoiceList.appointment_date.bdate).format('YYYY-MM-DD') + ' ' + this.props.preInvoiceData.preInvoiceList.appointment_date.start),
            enddatetime:moment(moment(this.props.preInvoiceData.preInvoiceList.appointment_date.bdate).format('YYYY-MM-DD') + ' ' + this.props.preInvoiceData.preInvoiceList.appointment_date.end),
            firstConsultationConfiguration:(this.props.preInvoiceData.preInvoiceList && this.props.preInvoiceData.preInvoiceList.firstConsultationConfiguration)||[],

            // related_party_obj: related_party_name,
            // requested_professional_obj: related_professional_name,
            billing_policy_id:this.props.preInvoiceData.preInvoiceList.billing_policy_id
          },()=>{
           this.updateStartEndTimeInLineItems();
          });
        }
      }
    }

    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 500);
  }

  updateStartEndTimeInLineItems = () => {
      
    if(this.state.startdatetime || this.state.enddatetime){
      let list = [...this.state.lineItemsArray];
      if(list && list.length > 0){
        list.forEach((item, index)=>{
          if(item.delete !== true){
            list[index].startdatetime =  this.state.startdatetime ? moment(this.state.startdatetime).format("YYYY-MM-DD HH:mm"): "" ;
            list[index].enddatetime =  this.state.enddatetime ? moment(this.state.enddatetime).format("YYYY-MM-DD HH:mm"): "" ;
          }
         })
        this.setState({
          lineItemsArray: list
        })
      }
    }
    }



  handleOnChangePatient = async (value, event) => {
    //console.log("Value is - ", value);
    // await this.props.fetchpatient(event.children);
    const emailVal =
      this.props.patientData &&
      this.props.patientData.patient &&
      this.props.patientData.patient.find((element, index) => {
        return element.patient_id == value;
      });
    this.setState({
      email: emailVal && emailVal.email? emailVal.email: "",
    });
  };

  onChangePatient = (value) => {
    //console.log(`selected ${value}`);
    this.setState({
      patient_name: value,
      related_party: value,
    });
  };

  onChangePratitioner = (value, name) => {
    this.setState({
      [name]: value,
    });
  };

  isEndDateValid = (current) => {
    let yesterday = this.state.startdatetime ? moment(this.state.startdatetime).subtract( 1, 'day' ) : moment().subtract( 1, 'day' ); 
    return current.isAfter(yesterday);
  }

  isStartDateValid = (current) => {
    // let yesterday = moment().subtract( 1, 'day' ); 
    return current.isBefore(moment());
  }

  handleChangeDate = (date, name) => {
    this.setState({
      [name]: date,
    });
    if(name === "startdatetime" || name === "enddatetime"){
      let list = [...this.state.lineItemsArray];
      if(list && list.length > 0){
        list.forEach((item, index)=>{
          if(item.delete !== true){
            list[index].startdatetime =  this.state.startdatetime ? moment(this.state.startdatetime).format("YYYY-MM-DD HH:mm"): "" ;
            list[index].enddatetime =  this.state.enddatetime ? moment(this.state.enddatetime).format("YYYY-MM-DD HH:mm"): "" ;
          }
         })
        this.setState({
          lineItemsArray: list
        })
      }
    }
  };
  

  // common diagnosis handlechange
  handleInputChange = (event, index) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
    if (name === "patient_type") {
      this.setState({
        place_of_treatment_code: "",
      });
    }
  };

  gotoInvoiceList = () => {
    history.push("/invoicelist");
  };

  viewEstimate = () => {
    this.props.history.push({
      pathname: "/app/estimatedetails/"+ this.state.invoice_id,
    });
  }

  toggleSelectionModal = () => {

    let lineItemsArray = [...this.state.lineItemsArray];
    let claimed_amount = 0;
    if(lineItemsArray && lineItemsArray.length > 0 && this.state.isSelectionModal === false ){
      lineItemsArray.forEach((item, index)=>{
        if(item.delete !== true && item.isClaimed === 1){
          //lineItemsArray[index].isClaimed = 1;
            claimed_amount += Number(item.price);
        }
      })
    }

    this.setState({
      isSelectionModal: !this.state.isSelectionModal,
      lineItemsArray: lineItemsArray,
      claimed_amount: claimed_amount ? claimed_amount.toFixed(2): 0 ,
      //isAllClaimed: 1
    });
  }

  // Send party and doctor data to receive payment
  onSubmit = async (param) => {

    //console.log("his.state.btnFlag", this.state.btnFlag);
    if(this.state.btnFlag === "3" && !this.state.isSelectionDone){
        this.toggleSelectionModal();
        return false;
    }

    this.setState({
      isLoading: true,
      errorMessage: ""
    });

    // Payload to be sent
    const payload = {
      associated_related_party_id: this.state.related_party,
      requested_related_party_id: this.state.requested_professional,
      sub_total: this.state.sub_total,
      vat_amount: this.state.vat_amount,
      total: this.state.total,
      height: this.state.height ? this.state.height : "",
      weight: this.state.weight? this.state.weight : "",
      claimed_amount: this.state.claimed_amount,
      patient_liable_amount: this.state.patient_liable_amount,
      //scheme_liable_amount: this.state.scheme_liable_amount,
      amount_paid: this.state.amount_paid,
      balance: this.state.balance,
      vat_percent: this.state.vat_percent,
      billTo: this.state.bill_to,
      address: this.state.address? this.state.address: "",
      billing_email: this.state.email?this.state.email :"",
      invoice_date: moment(this.state.date).format("YYYY-MM-DD"),
      invoice_type_id: this.state.invoice_type_id,
      patient_type: this.state.patient_type,
      place_of_treatment_code: this.state.place_of_treatment_code,
      //billing_policy_configuration_id: this.state.billing_policy_configuration_id,
      //billing_policy_value: this.state.billing_policy_value,
      referring_practitioner_id: this.state.referring_practitioner_id,
      referring_to_practitioner_id: this.state.referring_to_practitioner_id,
      invoice_list_type: this.state.btnFlag === "3" ? 1 : 2,
      line_items: this.state.lineItemsArray,
      appointment_id: this.state.appoinment_id,
      conductappointment_id: this.state.conductappointment_id,
      diagnosis_codes: this.state.diagnosis_codes,
      authorization_number: this.state.authorization_number,
      claimAsAssistant: this.state.claimAsAssistant,
      startdatetime: moment(this.state.startdatetime).format("YYYY-MM-DD HH:mm"),
      enddatetime: moment(this.state.enddatetime).format("YYYY-MM-DD HH:mm"),
      isEstimate: this.state.isEstimate,
      discount:this.state.discount,
      zeroModal: param
    };
    if (
      this.props.location.state &&
      this.props.location.state.paymentrecieved_id) {
      payload.paymentrecieved_id = this.props.location.state.paymentrecieved_id;
    }
    // console.log("**********", payload);
    if (
      this.props.location.state &&
      this.props.location.state.is_appointment_conducted == false &&
      this.props.location.state &&
      this.props.location.state.paymentType == 1
    ) {
      payload.appointment_reason = this.state.appointment_reason;
      payload.description = this.state.description;
    }

    if (this.state.invoice_id) {
      payload.invoice_id = this.state.invoice_id
    }

    if (this.state.btnFlag === "3") {
      if (this.state.resubmission_code) {
        payload.resubmission_code = this.state.resubmission_code;
      } else {
        payload.submitClaim = true;
      }
    }


    // Headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
          this.setState({
          isLoading: false,
          isSelectionDone: false,
          errorMessage: ""
        });
      const response = await api.post("payment/invoice/save", payload, {
        headers: headers,
      });
     // console.log("************response", response.data.data.invoice_id);
      if (response.status === 200) {
        let message = "Invoice saved successfully! Please wait while redirecting...";
        if(this.state.isEstimate === 1){
          message = "Estimate saved successfully! Please wait while redirecting...";
        }
        this.setState({
          isLoading: false,
          successMessage: message,
        });
        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
          if(this.state.isEstimate === 0){
            if (this.state.btnFlag === "1") {
              if (
                this.props.location.state &&
                checkIfPermitted(Permissions.VIEW_INVOICE) &&
                this.props.location.state.paymentrecieved_id
              ) {
                this.props.history.push({
                  pathname: "/app/invoicedetails",
                  state: {
                    isManageAppointment: this.props.location.state
                      .isManageAppointment,
                    related_party: this.props.location.state.related_party,
                    requsted_professional: this.props.location.state
                      .requsted_professional,
                    appointment_id: this.state.appoinment_id,
                    conductappointment_id: this.state.conductappointment_id,
                    invoice_id: response.data.data.invoice_id,
                    appointment_reason:
                      this.props.location.state &&
                      this.props.location.state.appointment_reason,
                    is_appointment_conducted:
                      this.props.location.state &&
                      this.props.location.state.is_appointment_conducted,
                    paymentType:
                      this.props.location.state &&
                      this.props.location.state.paymentType,
                  },
                });
              } else {
                this.gotoInvoiceList();
              }
            } else if (this.state.btnFlag === "2") {
              this.props.history.push({
                pathname: "/app/receivepayment",
                state: {
                  patient_id: this.state.related_party,
                  practitioner_id: this.state.requested_professional,
                  appointment_id: this.state.appoinment_id,
                  conductappointment_id: this.state.conductappointment_id,
                  invoice_id: response.data.data.invoice_id,
                  isAppointmentPay: true,
                  amount: Math.sign(this.state.balance) === 1 ? Number(this.state.balance) : 0
                },
              });
            } else if (this.state.btnFlag === "3") {
              // this.props.history.push({
              //   pathname: "/app/claimprocess",
              //   state: {
              //     isManageAppointment: this.props.location.state && 
              //       this.props.location.state.isManageAppointment,
              //     related_party: this.state.related_party,
              //     requested_professional:  this.state.requested_professional,
              //     appointment_id: this.state.appoinment_id,
              //     conductappointment_id: this.state.conductappointment_id,
              //     invoice_id: response.data.data.invoice_id,
              //     resubmission_code: this.state.resubmission_code,
              //   },
              // });
  
              this.gotoInvoiceList();
            }
          }else if(this.state.isEstimate === 1){
            if (this.state.btnFlag === "1") {
              if (
                checkIfPermitted(Permissions.VIEW_INVOICE)
              ) {
                this.props.history.push({
                  pathname: "/app/estimatedetails/"+response.data.data.invoice_id,
                });
              }
            }
        }

        }, 2000);
      }
    } catch (error) {
      if (error.response) {
        //console.log("error.response", error.response.data)
        this.setState({
          isLoading: false,
          isSelectionDone: false,
          errorMessage: error.response.data &&
            error.response.data.message ? error.response.data.message : "Internal server error occured",
        });
        // setTimeout(() => {
        //   this.setState({
        //     errorMessage: "",
        //   });
        // }, 4000);
      }
      // console.log("Create room error", error);
    }
  };


  updateState = (data) => {
    this.setState({
      lineItemsArray: data.lineItemsArray,
      diagnosis_codes: data.diagnosis_codes,
      vat_amount: data.vatPrice,
      sub_total: data.subTotal,
      total: data.grandTotal,
      claimed_amount: data.claimed_amount,
      patient_liable_amount: data.patient_liable_amount,
      amount_paid: data.amount_paid,
      balance: data.balance
    })
  }

  updateHeightWeight = (data) => {
    console.log("data", data.height)
    this.setState({
      height: data.height,
      weight: data.weight,
    })
  }

  setFlag = (flag) => {
    this.setState({
      btnFlag: flag
    })
  }

  handleCheckbox = (event) => {
    event.persist();
    const val = event.target.checked;
    const name = event.target.name;
    this.setState(
      {
        [name]: val ? 1 : 0,
      });
  };


  detailFormatter = (data) => {
    if (!data) {
        return "NA";
    } else {
        return data ? (data.charAt(0).toUpperCase() + data.slice(1)) : "Not Available";
    }
}

checkValidData = (data) => {
  if (!data) {
      return "NA";
  } else {
      return data;
  }
}

checkValidPrice = (data) => {
  if (data || data === 0) {
      return data;
  } else {
      return "NA";
  }
}

getPractitionerName = (doctor_id) => {
  
  const practitionerOptions =
  this.props.combinedPractitionersData && this.props.combinedPractitionersData.combinedPractitioners;

  const practitionerData = practitionerOptions && practitionerOptions.find((item)=>(
    item.practitioner_id === doctor_id
  ))

return practitionerData && practitionerData.practitioner_name ? practitionerData.practitioner_name : ""

}

submitForClaim = (param) => {
  let lineItemsArray = [...this.state.lineItemsArray];
  if(lineItemsArray && lineItemsArray.length > 0){
    let claimItemExists = lineItemsArray.filter((item) => (
      item.delete !== true && item.isClaimed === 1
    ))
    if(claimItemExists && claimItemExists.length > 0){
      this.setState({
        claimLineNotSelectedErr: "",
        isSelectionModal: false,
        isSelectionDone: true
      },()=>{
        this.onSubmit(param);
      })
    }else {
      this.setState({
        claimLineNotSelectedErr: "Please select line items to claim!"
      })
      // setTimeout(() => {
      //   this.setState({
      //     claimLineNotSelectedErr: ""
      //   });
      // }, 4000);
    }
  }else{

  }
}

handleSelectFinalAll = (event) => {
  //event.persist();
  const val = event.target.checked;
  const name = event.target.name;
  let lineItemsArray = [...this.state.lineItemsArray];
  let claimed_amount = 0;
  if (lineItemsArray.length > 0) {
    lineItemsArray.forEach((item) => {
      if ( item.delete !== true) {
        item.isClaimed = val ? 1 : 0;
        if(item.isClaimed === 1){
          claimed_amount += Number(item.price);
        }
      }
    })
  }
  this.setState(
    {
      lineItemsArray: lineItemsArray,
      isAllClaimed: val ? 1 : 0,
      claimed_amount: claimed_amount ? claimed_amount.toFixed(2) : 0
    });

};

handleInputCheckBoxChange = (event, reference_id) => {
  console.log("checkbox clicked", event)
  console.log("state line items", this.state.lineItemsArray)
  //event.persist();
  //console.log("reference_id", reference_id)
  const val = event.target.checked;
  //const name = event.target.name;
  let claimed_amount = 0;
  let lineItemsArray = [...this.state.lineItemsArray];
  if (lineItemsArray && lineItemsArray.length > 0) {
    let index = lineItemsArray.findIndex((item)=>(
      item.reference_id === reference_id && item.delete !== true
    ))
    lineItemsArray[index].isClaimed = val ? 1 : 0;
   
    lineItemsArray.forEach(element => {
      if(element.delete !== true && element.isClaimed === 1){
        claimed_amount += Number(element.price);
      }
    })
  }
console.log("lineItem", lineItemsArray)
  this.setState(
    {
      lineItemsArray: lineItemsArray,
      isAllClaimed: 0,
      claimed_amount: claimed_amount ? claimed_amount.toFixed(2) : 0
    });
};


  render() {
   // console.log("state", this.state)
    const patientOptions =
      this.props.patientData && this.props.patientData.patient;

    const practitionerOptions =
      this.props.practitionerData && this.props.practitionerData.practitioner;

      const combinedPractitioners = this.props.combinedPractitionersData &&
      this.props.combinedPractitionersData.combinedPractitioners;

      const externalPractitioners = this.props.externalPractitionersAutoCompData && 
      this.props.externalPractitionersAutoCompData.externalPractitionersAutoComp;

    const invoiceType = this.props.dropdownListData.dropdownList.lk_invoice_type;
    const invoiceTypeOptions = invoiceType &&
      invoiceType.map((element, index) => (
        <option key={index} value={element.lk_invoice_type_id}>
          {element.invoice_type}
        </option>
      ));

    const placeOfTreatment = this.props.dropdownListData.dropdownList.lk_place_of_treatement;
    const placeOfTreatmentOptions = placeOfTreatment &&
      placeOfTreatment.map((element, index) => (
        parseInt(this.state.patient_type) === element.type && (
          <option key={index} value={element.code}>
            {element.place}
          </option>)
      ));


    // const billingPolicy = this.props.dropdownListData.dropdownList.billing_policy;
    // const billingPolicyOptions = billingPolicy &&
    //   billingPolicy.map((element, index) => (
    //     <option key={index} value={element.billing_policy_id}>
    //       {element.billing_policy}
    //     </option>
    //   ));

      let billingPolicy = [];

      if(this.state.invoice_id && this.props.invoiceDataDetails && this.props.invoiceDataDetails.invoiceData){
        billingPolicy = this.props.invoiceDataDetails.invoiceData && 
        this.props.invoiceDataDetails.invoiceData.billingPolicyConfiguration;
      }else if(this.props.preInvoiceData && this.props.preInvoiceData.preInvoiceList) {
        billingPolicy = this.props.preInvoiceData.preInvoiceList && 
        this.props.preInvoiceData.preInvoiceList.billingPolicyConfiguration;
      }

      const billingPolicyOptions = billingPolicy && billingPolicy.length > 0 &&
        billingPolicy.map((element, index) => (
          <option key={index} value={element.billing_policy_configuration_id}>
            {element.billing_policy}
          </option>
        ));


    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    return (
      <div className={style.createInvoiceWrapper}>
        <div className="row">
          <div className="col-lg-12">
            <h3>{this.state.title}</h3>
          </div>
          <div className="col-lg-12 intro-text">
            {this.props.match.params.id ? (
            <p>
              The Edit {this.state.isEstimate === 0 ? "Invoice": "Estimate"} feature allows a user to open up an existing {this.state.isEstimate === 0 ? "Invoice": "Estimate"} for any changes that may be required.
            </p>): (
              <p className="mb-4">
              This is the form to create a new {this.state.isEstimate === 0 ? "invoice": "estimate"} which is applicable for
              appointments. For appointments, mostly the data on the form will be prefilled.
            </p>
            )}
          </div>
        </div>
        <Formik
          initialValues={this.state}
          enableReinitialize={true}
          validationSchema={Yup.object().shape({
            invoice_type_id: Yup.string().required(`${this.state.isEstimate === 0 ? "Invoice": "Estimate"} Type is required`),
            related_party: Yup.string().required("Patient Name is required"),
            email: Yup.string()
              .email("Email is invalid"),
              //.required("Patient Email is required"),
            //address: Yup.string().required("Paitent Address is required"),
            patient_type: Yup.string().required("Patient Type is required"),
            place_of_treatment_code: Yup.string().required("Place of Treatment is required"),
            date: Yup.string().required(`${this.state.isEstimate === 0 ? "Invoice": "Estimate"} Date is required`),
            // startdatetime: Yup.string().required("Start time is required"),
            // enddatetime: Yup.string().required("End time is required")
            startdatetime :Yup.mixed().required('Start time is required').test('from-greater-than-to', 'Start time should be less than end time', function(value) {
              return moment(value).isBefore(moment(this.parent.enddatetime));
          }).test('from-greater-than-to', 'Start time should not be future date', function(value) {
            return moment(value).isSameOrBefore(moment());
        }),
            enddatetime: Yup.mixed().required('End time is required').test('from-less-than-to', 'End time should be greater than start time', function(value) {
                return moment(value).isAfter(moment(this.parent.startdatetime));
            }),
           // billing_policy_id: Yup.string().required("Billing Policy is required"),
            requested_professional: Yup.string().required("Practitioner is required"),
            lineItemsArray: Yup.array().of(
              Yup.object().shape({
                line_type: Yup.string()
                  .required("Required!"),
                tariff_code: Yup.string()
                  .required("Required!"),
                diagnosis_code: Yup.string()
                  .required("Required!"),
                doctor_id: Yup.string()
                  .required("Required!"),
                quantity: Yup.string()
                  .required("Required!")
                  .matches(/^[0-9]\d{0,9}(\.\d{1,2})?%?$/, "Only numbers allowed"),
                price: Yup.string()
                  .required("Required!")
                  //.matches(/^[0-9]*$/, "Only numbers allowed"),
                  .matches(/^[0-9]\d{0,9}(\.\d{1,2})?%?$/, "Only numbers allowed"),
              })
            ),
          })}
          onSubmit={this.onSubmit}
        >
          {({ errors, status, touched }) => (

            <Form>
              <div className="form-box-shadow mt-2">
                <div className="row">
                  <div className="col-lg-12">
                    <h5>{this.state.isEstimate === 0 ? "Invoice": "Estimate"} Details</h5>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="invoice_type_id">{this.state.isEstimate === 0 ? "Invoice": "Estimate"} Type{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>

                      <Field
                        as="select"
                        name="invoice_type_id"
                        disabled={this.state.resubmission_code}
                        className={
                          "form-control" +
                          (errors.invoice_type_id && touched.invoice_type_id
                            ? " is-invalid"
                            : "")
                        }
                        onChange={this.handleInputChange}

                      >
                        <option value="">Select {this.state.isEstimate === 0 ? "Invoice": "Estimate"} Type</option>
                        {invoiceTypeOptions}
                      </Field>
                      <ErrorMessage
                        name="invoice_type_id"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="related_party">Patient Name{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>
                      <Select
                        showSearch
                        allowClear={true}
                        name="related_party"
                        placeholder="Search Patient"
                        optionFilterProp="children"
                        disabled={this.state.invoice_id || this.state.conductappointment_id ||
                          this.state.appoinment_id}
                        onChange={this.onChangePatient}
                        onSelect={(value, event) =>
                          this.handleOnChangePatient(value, event)
                        }
                        className={
                          (errors.related_party && touched.related_party
                            ? " is-invalid"
                            : "")
                        }
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={this.state.related_party || undefined}
                      >
                        {patientOptions &&
                          patientOptions.map((element, index) => (
                            <Option key={index} value={element.patient_id}>
                              {element.patient_name}
                            </Option>
                          ))}
                      </Select>
                      <ErrorMessage
                        name="related_party"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="email">Patient Email{" "}</label>

                      <Field
                        type="text"
                        name="email"
                        placeholder="Patient Email"
                        //disabled={this.state.related_party}
                        className={
                          "form-control" +
                          (errors.email && touched.email
                            ? " is-invalid"
                            : "")
                        }
                        onChange={this.handleInputChange}

                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="address">Patient Address{" "}</label>

                      <Field
                        name="address"
                        type="text"
                        placeholder="Patient Address"
                        maxLength="35"
                        className={
                          "form-control" +
                          (errors.address && touched.address
                            ? " is-invalid"
                            : "")
                        }
                        onChange={this.handleInputChange}
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="patient_type">Patient Type
                      {" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>
                      <Field
                        as="select"
                        name="patient_type"
                        onChange={this.handleInputChange}
                        className={
                          "form-control" +
                          (errors.patient_type && touched.patient_type
                            ? " is-invalid"
                            : "")
                        }
                      >
                        <option value="">Select Patient Type</option>
                        <option value="01">Out Patient</option>
                        <option value="02">In Hospital Patient</option>
                      </Field>
                      <ErrorMessage
                        name="patient_type"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="place_of_treatment_code">
                        Place of Treatment{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>
                      <Field
                        as="select"
                        name="place_of_treatment_code"
                        onChange={this.handleInputChange}
                        className={
                          "form-control" +
                          (errors.place_of_treatment_code && touched.place_of_treatment_code
                            ? " is-invalid"
                            : "")
                        }
                      >
                        <option value="">Select Place of Treatment</option>
                        {placeOfTreatmentOptions}
                      </Field>
                      <ErrorMessage
                        name="place_of_treatment_code"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="date">{this.state.isEstimate === 0 ? "Invoice": "Estimate"} Date{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>

                      <DatePicker
                        selected={
                          this.state.date ? new Date(this.state.date) : null
                        }
                        onChange={(date)=>this.handleChangeDate(date, "date")}
                        id="date"
                        name="date"
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Date"
                        defaultValue={moment()}
                        value={moment(this.state.date)}
                        className={
                          "form-control" +
                          (errors.date && touched.date
                            ? " is-invalid"
                            : "")
                        }
                      />
                      <ErrorMessage
                        name="date"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>


                   <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="billing_policy_configuration_id">
                        Billing Policy{" "}</label>
                      <Field
                        as="select"
                        name="billing_policy_configuration_id"
                        //onChange={this.handleInputChange}
                        value={this.state.billing_policy_configuration_id}
                         disabled={true}
                        className={
                          "form-control" +
                          (errors.billing_policy_configuration_id && touched.billing_policy_configuration_id
                            ? " is-invalid"
                            : "")
                        }
                      >
                        <option value="">Select Billing Policy</option>
                        {billingPolicyOptions}
                      </Field>
                      <ErrorMessage
                        name="billing_policy_configuration_id"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="requested_professional">
                        Practitioner{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>
                      <Select
                        showSearch
                        allowClear={true}
                        name="requested_professional"
                        disabled={this.state.invoice_id || this.state.conductappointment_id ||
                        this.state.appoinment_id}
                        placeholder="Search Practitioner"
                        optionFilterProp="children"
                        onChange={(value, event) => this.onChangePratitioner(value, "requested_professional")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={this.state.requested_professional || undefined}
                        className={
                          (errors.requested_professional && touched.requested_professional
                            ? " is-invalid"
                            : "")
                        }
                      >
                        {practitionerOptions &&
                          practitionerOptions.map((element, index) => (
                            <Option key={index} value={element.practitioner_id}>
                              {element.practitioner_name}
                            </Option>
                          ))}
                      </Select>
                      <ErrorMessage
                        name="requested_professional"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>


                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="referring_practitioner_id">
                        Referring Doctor</label>
                      <Select
                        showSearch
                        allowClear={true}
                        name="referring_practitioner_id"
                        placeholder="Search Doctor"
                        optionFilterProp="children"
                        onChange={(value, event) => this.onChangePratitioner(value, "referring_practitioner_id")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={this.state.referring_practitioner_id || undefined}
                        className={
                          (errors.referring_practitioner_id && touched.referring_practitioner_id
                            ? " is-invalid"
                            : "")
                        }
                      >
                        {externalPractitioners &&
                          externalPractitioners.map((element, index) => (
                            <Option key={index} value={element.practitioner_id}>
                              {element.practitioner_name}
                            </Option>
                          ))}
                      </Select>
                      <ErrorMessage
                        name="referring_practitioner_id"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="referring_to_practitioner_id">
                        Referred To Doctor</label>
                      <Select
                        showSearch
                        allowClear={true}
                        name="referring_to_practitioner_id"
                        placeholder="Search Doctor"
                        optionFilterProp="children"
                        onChange={(value, event) => this.onChangePratitioner(value, "referring_to_practitioner_id")}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={this.state.referring_to_practitioner_id || undefined}
                        className={
                          (errors.referring_to_practitioner_id && touched.referring_to_practitioner_id
                            ? " is-invalid"
                            : "")
                        }
                      >
                        {externalPractitioners &&
                          externalPractitioners.map((element, index) => (
                            <Option key={index} value={element.practitioner_id}>
                              {element.practitioner_name}
                            </Option>
                          ))}
                      </Select>
                      <ErrorMessage
                        name="referring_to_practitioner_id"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>


                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="date">Treatment Start Time{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>
                      <Datetime 
                      isValidDate={this.isStartDateValid}
                        onChange={(d)=>this.handleChangeDate(d, "startdatetime")}
                        inputProps={{
                          placeholder: "YYYY-MM-DD HH:MM",
                          className:`form-control
                            ${(errors.startdatetime && touched.startdatetime
                              ? " is-invalid"
                              : "")}`,
                        name:"startdatetime" 
                       }}
                       name="startdatetime"
                       className={
                         (errors.startdatetime && touched.startdatetime
                           ? " is-invalid"
                           : "")
                       }
                        initialValue={this.state.startdatetime || null}
                        dateFormat="YYYY-MM-DD"
                        timeFormat="HH:mm"/>
                      <ErrorMessage
                        name="startdatetime"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="date">Treatment End Time{" "}
                        <span className="mandatory">
                          <small>*</small>
                        </span></label>
                      <Datetime 
                      isValidDate={this.isEndDateValid}
                        onChange={(d)=>this.handleChangeDate(d, "enddatetime")}
                        inputProps={{
                          placeholder: "YYYY-MM-DD HH:MM",
                          name:"enddatetime",
                          className:`form-control
                            ${(errors.enddatetime && touched.enddatetime
                              ? " is-invalid"
                              : "")}`,
                       }}
                       name="enddatetime" 
                        initialValue={this.state.enddatetime || null}
                        className={
                          (errors.enddatetime && touched.enddatetime
                            ? " is-invalid"
                            : "")
                        }
                        dateFormat="YYYY-MM-DD"
                        timeFormat="HH:mm"/>
                      <ErrorMessage
                        name="enddatetime"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>
                  {this.state.isMedicalAidPatient===0 && (
                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div className="form-group">
                      <label htmlFor="address">Discount %</label>

                      <Field
                        name="discount"
                        type="text"
                        placeholder="Discount %"
                        className={
                          "form-control" +
                          (errors.discount && touched.discount
                            ? " is-invalid"
                            : "")
                        }
                        onChange={this.handleInputChange}
                      />
                      <ErrorMessage
                        name="discount"
                        component="div"
                        className="invalid-feedback"
                      />
                    </div>
                  </div>)}

                  <div className="col-md-6 col-lg-4 col-xl-3">
                    <div
                      className={`custom-control custom-checkbox ${style.claimAsAssistant}`}
                    >
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="claimAsAssistant"
                        name="claimAsAssistant"
                        onChange={this.handleCheckbox}
                        checked={this.state.claimAsAssistant === 1}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="claimAsAssistant"
                      >
                        Claim as Assistant
                        </label>
                    </div>
                  </div>


                </div>
              </div>
              <div className="mt-4">
                <BillingComponent
                  {...this.state}
                  {...{ errors, status, touched }}
                  practitionerOptions={practitionerOptions}
                  combinedPractitioners={combinedPractitioners}
                  state={this.state}
                  updateState={this.updateState}
                  updateHeightWeight={this.updateHeightWeight}
                ></BillingComponent>
              </div>

              <div className="row">
                <div className="col-md-12">
                  {this.state.error && (
                    <div className={`error ${style.errorText}`}>
                      {this.state.error}
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                {Object.keys(errors).length > 0 && (
                  <div className="text-danger mt-2">
                      Please fill all mandatory fields!
                  </div>
              )}
                  {this.state.isLoading ? (
                    <div className={style.loadingWrapper}>
                      <img src={ttmLoader} alt="loader" className={style.loading} />
                    </div>
                  ) : (
                      <div>
                        {this.state.successMessage && (
                          <p className={style.successMessage}>
                            {this.state.successMessage}
                          </p>
                        )}
                        {this.state.errorMessage && (
                          <p className={style.errorMessage}>
                            {this.state.errorMessage}
                          </p>
                        )}
                      </div>
                    )}
                </div>
              </div>

              <div className="row">
              {this.state.isEstimate === 1 && (
              <div
                  className={`col-lg-12 d-flex justify-content-end flex-column-reverse flex-md-row align-items-center ${style.createInvoiceBtnWrapper}`}
                >
                {this.state.invoice_id && checkIfPermitted(Permissions.VIEW_INVOICE) &&(<div>
                  <Button
                    className="form-primary-btn mr-3"
                    type="button"
                    onClick={this.viewEstimate}
                  >
                    View Estimate Details
                  </Button>
                </div>)}
                  
                    <div>
                      <Button
                        className="form-primary-btn"
                        type="submit"
                        onClick={() => this.setFlag("1")}
                      >
                        Save Estimate
                      </Button>
                    </div>
                </div>)}
                {this.state.isEstimate === 0 && (
                <div
                  className={`col-lg-12 d-flex justify-content-end flex-column-reverse flex-md-row align-items-center ${style.createInvoiceBtnWrapper}`}
                >
                  {!this.state.resubmission_code && (
                    <div>
                      <Button
                        className="form-primary-btn"
                        type="submit"
                        onClick={() => this.setFlag("1")}
                      >
                        Save Invoice
                      </Button>
                      {checkIfPermitted(Permissions.RECIEVE_PAYMENT) && (
                        <Button
                          type="submit"
                          className="form-primary-btn ml-2"
                          onClick={() => this.setFlag("2")}
                        >
                          Receive Payment
                        </Button>
                      )}
                      {(Number(this.state.invoice_type_id) === 1) && this.state.conductappointment_id && (
                          <Button
                            className="form-primary-btn ml-2"
                            type="submit"
                            onClick={() => this.setFlag("3")}
                          >
                            Proceed to Claim
                          </Button>
                        )}
                    </div>
                  )}
                  {this.state.resubmission_code && (
                    <Button
                      className="form-primary-btn ml-2"
                      type="submit"
                      onClick={() => this.setFlag("3")}
                    >
                      Proceed to Resubmission
                    </Button>
                  )}
                </div>)}
              </div>
            </Form>
          )}
        </Formik>

{/*Select final line items pop up  */}
        <Modal
            isOpen={this.state.isSelectionModal}
            toggle={this.toggleSelectionModal}
            className="lineItemsSelectionModal"
            centered
          >
            <ModalHeader
              toggle={this.toggleSelectionModal}
              className={style.deleteReasonHeader}
              >
              Claim
            </ModalHeader>
            <ModalBody>
          <React.Fragment>
          <div className={`row ${style.infoWrapper}`}>
                    <div className="col-12">
                        <p>Select the items which you want to claim for :</p>
                        <table className="table line-items-table">
                            <thead>
                                <tr>    
                                    <th className="select-col">
                                        <div className="custom-control custom-checkbox">
                                            <input
                                              type="checkbox"
                                              className="custom-control-input"
                                              id="finallineItems"
                                              name="finallineItems"
                                              disabled={this.state.lineItemsArray && this.state.lineItemsArray.length === 0}
                                              onChange={this.handleSelectFinalAll}
                                              checked={this.state.isAllClaimed} />
                                            <label
                                              className="custom-control-label"
                                              htmlFor="finallineItems"
                                            >
                                            </label>
                                        </div>
                                    </th>       
                                    <th>Line Item</th>
                                    <th>Tariff Code</th>
                                    <th>Nappi Code</th>
                                    <th className="invoice-desc-col">Description</th>                           
                                    <th>Quantity</th>
                                    <th>Doc./ Ass. Name</th>
                                    <th>Amount (ZAR)</th>
                                </tr>
                            </thead>
                            <tbody>
                            {this.state.lineItemsArray && this.state.lineItemsArray.length > 0 &&
              this.state.lineItemsArray.map(
                (element, i) => {
                  return (
                    element.delete !== true && (
                    <tr key={i}>     
                                    <td className="select-col">
                                        <div className="custom-control custom-checkbox">
                                        <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id={`Claim-${element.reference_id}`}
                                  name={`Claim-${element.reference_id}`}
                                  onChange={(e) =>
                                    this.handleInputCheckBoxChange(
                                      e,
                                      element.reference_id
                                    )
                                  }
                                  defaultValue={true}
                                  defaultChecked={true}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor={`Claim-${element.reference_id}`}
                                >
                                </label>
                                        </div>
                                    </td>                       
                                    <td>{this.detailFormatter(element.line_type)}</td>
                                    <td>{this.checkValidData(element.tariff_code)}</td>
                                    <td>{this.checkValidData(element.nappi_code)}</td>
                                    <td className="invoice-desc-col">{this.checkValidData(element.description)}</td>                            
                                    <td>{this.checkValidData(element.quantity)}</td>
                                    <td>{this.getPractitionerName(element.doctor_id)}</td>
                                    <td>{formatNumberToCurrency(element.price)}</td>
                                </tr>
                                ))})}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="billing-total-summary">
                            <p><span>Total invoice (ZAR): </span><span>{formatNumberToCurrency(this.state.total)}</span></p>
                            <p><span>Claimed amount (ZAR): </span><span>{formatNumberToCurrency(this.state.claimed_amount)}</span></p>
                            <p><span>Patient liable amount (ZAR): </span><span>{formatNumberToCurrency(this.state.patient_liable_amount)}</span></p>
                            <p><span>Scheme liable amount (ZAR): </span><span>{formatNumberToCurrency(this.state.scheme_liable_amount)}</span></p>
                            <p><span>Amount paid (ZAR): </span><span>{formatNumberToCurrency(this.state.amount_paid)}</span></p>
                            <p><span>Balance pay (ZAR): </span><span>{formatNumberToCurrency(this.state.balance)}</span></p>
                        </div>
                    </div>
                </div>                                
           <div className="row">
                <div className="col-md-12">
                  {this.state.claimLineNotSelectedErr && (
                    <div className={`error ${style.errorText}`}>
                      {this.state.claimLineNotSelectedErr}
                    </div>
                  )}
                </div>
              </div>
            <div className="d-flex justify-content-between modal-footer">
                <button type="button" onClick={this.toggleSelectionModal} className="tmed-btn tmed-primary-btn btn btn-secondary">Cancel</button>
                <button type="button" onClick={() => this.zeroModalPopup(this.state.lineItemsArray)} className="tmed-btn tmed-primary-btn btn btn-secondary">Claim</button>
            </div>
              </React.Fragment>
              </ModalBody>
              </Modal>



{/* R0.0 - R0.01 confimation pop up */}
                 <Modal
            isOpen={this.state.zeroModal}
            toggle={this.toggleSelectionModal}
            className="lineItemsSelectionModal"
            centered
          >
            <ModalHeader
              toggle={this.zeroModalPopup}
              className={style.deleteReasonHeader}
              >
              Important
            </ModalHeader>
            <ModalBody>
          <React.Fragment>
          <div className={`row ${style.infoWrapper}`}>
                    Please confirm R0.01 change in the payload for the R0.00 lines. 
               </div>
            <div className="d-flex justify-content-between modal-footer">
                <button type="button" onClick={() => this.zeroModalConfirmation(false)} className="tmed-btn tmed-primary-btn btn btn-secondary">No</button>
                <button type="button" onClick={() => this.zeroModalConfirmation(true)} className="tmed-btn tmed-primary-btn btn btn-secondary">Yes</button>
            </div>
              </React.Fragment>
              </ModalBody>
              </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    preInvoiceData: state.preInvoiceList,
    dropdownListData: state.dropdownList,
    practitionerData: state.practitioner,
    patientData: state.patient,
    invoiceDataDetails: state.invoiceData,
    relatedPartyData: state.relatedPartyData,
    combinedPractitionersData: state.combinedPractitioners,
    externalPractitionersAutoCompData: state.externalPractitionersAutoComp,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPreInvoice: (appointmentId, relatedPartyId, conductAPPId, isEstimate) =>
      dispatch(fetchPreInvoice(appointmentId, relatedPartyId, conductAPPId, isEstimate)),
    fetchpractitioner: (practitionerName) =>
      dispatch(fetchpractitioner(practitionerName)),
    fetchpatient: (patientName) => dispatch(fetchpatient(patientName)),
    fetchInvoiceData: (invoice_id) => dispatch(fetchInvoiceData(invoice_id)),
    fetchRelatedParty: (patient_id) => dispatch(fetchRelatedParty(patient_id)),
    fetchCombinedPractitioner: (practitionerName) => dispatch(fetchCombinedPractitioner(practitionerName, 1)),
    fetchExternalPractitionerAutoComp: (practitionerName) => dispatch(fetchExternalPractitionerAutoComp(practitionerName, 1)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateInvoice);
